import * as React from 'react';
import { connect } from 'react-redux';
import {ICreateProductState, IProduct, IUserData} from '../../infrastructure/interfaces';
import {Route} from "react-router";
import { productType } from '../../infrastructure/ProductType';
import {TemplateType, templateType} from '../../infrastructure/TemplateType';
import {setNewProductTemplateType} from "../../actions/actions";
import { History } from 'history'
import CreateProductModal from "../Modals/CreateProductModal/CreateProductModal";
import {
    saveProduct
} from "../../actions/actions";
import { getHomePageRoute } from '../../infrastructure/HomePageRoute';

const brochureTemplate = require('./images/Brochure_Template.JPG');
const bulletinTemplateA = require('./images/Bulletin_Template_A.JPG');
const bulletinTemplateB = require('./images/Bulletin_Template_B.JPG');
const catalogTemplateA = require('./images/Catalog_Template_A.JPG');
const catalogTemplateB = require('./images/Catalog_Template_B.JPG');

export interface ICreateProductTemplatePickerProps {
    createProductState: ICreateProductState;
    userData: IUserData;
    setNewTemplateType(templateType: TemplateType): void;
    saveProduct(originalName: string,
                product: IProduct,
                imagesFormData?: FormData,
                logoFormData?: FormData): void;
}

export interface ICreateProductTemplatePickerState extends React.ComponentState {
    showCreateModal: boolean;
}

const mapDispatchToProps = (dispatch: any): any => {
    return {
        saveProduct: (originalName: string, product: IProduct, image?: FormData, logo?: FormData) => {
            dispatch(saveProduct(originalName, product, image, logo));
        },
        setNewTemplateType: (templateType: TemplateType): void => {
            dispatch(setNewProductTemplateType(templateType));
        },
    };
};

const mapStateToProps = (state: any): any => {
    return {
        createProductState: state.createProductState,
        userData: state.user.data,
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CreateProductTemplatePicker extends React.Component<ICreateProductTemplatePickerProps, ICreateProductTemplatePickerState>{
    routerHistory:History<any>;

    constructor(props: ICreateProductTemplatePickerProps) {
        super(props);
        this.state = {
            showCreateModal: false,
        };
    }

    click(type: TemplateType, history: any) {
        this.routerHistory = history;
        this.props.setNewTemplateType(type);

        this.setState({
            showCreateModal: true,
        });
    }


    renderPortal(title: string, isEnabled: boolean, type: any, image?: string, description?: string): any {
        return (
            <Route
                render={({history}) => (
                    <div>
                        <button
                            disabled={!isEnabled}
                            className="portal"
                            onClick={() => this.click(type, history)}>

                            <div className="portal-wrapper">
                                <div className="portal-logo">
                                    <img src={image}/>
                                </div>
                                <div className="portal-title">
                                    <span>{title}</span>
                                    <div>{description}</div>
                                </div>
                            </div>
                        </button>
                    </div>)
                }/>
        );
    }

    render() {
        const {
            createProductState,
        } = this.props;

        const {
            showCreateModal,
        } = this.state;

        let docType = createProductState.documentType;

        if (showCreateModal) {
            return (
                <CreateProductModal
                    show={this.state.showCreateModal}
                    onClose={() => {this.setState({showCreateModal: false});}}
                    product={null}
                    isEditingExistingProduct={true}
                    saveProduct={(originalName: string,
                                    product: IProduct,
                                    imagesFormData?: FormData,
                                    logoFormData?: FormData) => {
                            this.props.saveProduct(originalName,
                                                    product,
                                                    imagesFormData,
                                                    logoFormData);
                            const homePageRoute = getHomePageRoute(this.props.userData.role);
                            this.routerHistory.push(homePageRoute);
                        }
                    }
                    createProductState={this.props.createProductState}
                    productType={docType}
                />
            );
        }


        return(
            <div className="createProductLp-wrapper">
                <div className="createProductLp-header">
                    <div className="lp-headline">Choose the Template for Your Product Display</div>
                    <div className="optionText">Click one option below</div>
                </div>
                <div className="createProductLp-body">
                    {docType == productType.Bulletin ? this.renderPortal('Template A', true, templateType.Bulletin_A, bulletinTemplateA, "Product Image shown vertically") : ""}
                    {docType == productType.Bulletin ? this.renderPortal('Template B', true, templateType.Bulletin_B, bulletinTemplateB, "Product Image shown horizontally") : ""}

                    {docType == productType.Catalog ? this.renderPortal('Template A', true, templateType.Catalog_A, catalogTemplateA, "Product Image shown vertically") : ""}
                    {docType == productType.Catalog ? this.renderPortal('Template B', true, templateType.Catalog_B, catalogTemplateB, "Product Image shown horizontally") : ""}

                    {docType == productType.Brochure ? this.renderPortal('Template A', true, templateType.Brochure, brochureTemplate, "") : ""}

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateProductWizard/CreateProductTemplatePicker.tsx